<template>
  <div class="contact-box">
   <van-nav-bar
   :title="title"
   left-text="返回"
   left-arrow
   @click-left="onClickLeft"/>
  </div>
</template>

  <script>
  import { NavBar,Icon,Row, Col,DropdownMenu,DropdownItem} from 'vant';
  export default {
    props: ["title"],
    data() {
      return {};
      title:"";
    },
    components: {
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Row.name]: Row,
      [Col.name]: Col,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
    },
    
    methods: {
    go(pathName) {
      this.$router.push({ name: pathName });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    }
  };
  </script>

  <style lang="less" scoped>
    /deep/.van-nav-bar{ background:#fff; border-bottom:none;}

   /deep/.van-dropdown-menu{ background:none;}
   /deep/.van-dropdown-menu__title{ color:#fff!important;}
   /deep/.van-dropdown-menu__title::after{ display:none;}
   .sign_out{ color:#fff;}
   /deep/.van-nav-bar .van-icon{color: #000;margin-top: -2px;}
  </style>